import { render, staticRenderFns } from "./payrollaccuralsassigned.vue?vue&type=template&id=2abec69e"
import script from "./payrollaccuralsassigned.vue?vue&type=script&lang=js"
export * from "./payrollaccuralsassigned.vue?vue&type=script&lang=js"
import style0 from "./payrollaccuralsassigned.vue?vue&type=style&index=0&id=2abec69e&prod&lang=css"
import style1 from "./payrollaccuralsassigned.vue?vue&type=style&index=1&id=2abec69e&prod&slot-scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports